export default __webpack_public_path__ + "static/media/down_arrow_large.065671fb.svg";